module.exports = __webpack_public_path__ + "img/boodil-logo.98a1deaf.png";